import { Modal, Button } from "react-bootstrap";

type DeleteModalProps = {
  show: boolean;
  handleClose: () => void;
  handleDelete: (index: number) => void;
  title?: string;
  index: number;
};

const DeleteModal = ({ show, handleClose, handleDelete, title, index }: DeleteModalProps) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmation de suppression</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        Es-tu sûr de vouloir supprimer <strong>« {title} »</strong> ?
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Annuler
        </Button>
        <Button variant="danger" onClick={() => handleDelete(index)}>
          Supprimer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
